import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=9c65fc44&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=9c65fc44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c65fc44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c65fc44')) {
      api.createRecord('9c65fc44', component.options)
    } else {
      api.reload('9c65fc44', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=9c65fc44&scoped=true&", function () {
      api.rerender('9c65fc44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personalCenter/myAddress/detail.vue"
export default component.exports